import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel, { Optional } from "@/__main__/data-model.mjs";

export const player = {
  accountId: String,
  name: String,
  anonymous: Boolean,
  character: Optional(String),
} satisfies ModelDefinition;

const validateFn = createModel({
  data: {
    player,
  },
}).transform(player, (response) => response.data.player);

export type Player = FromModel<typeof validateFn>;

export default validateFn;
